/* eslint-disable */
import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M3 18H1.5V22.5H6V21H3V18Z" }),
    React.createElement("path", { d: "M3 3H6V1.5H1.5V6H3V3Z" }),
    React.createElement("path", { d: "M21 21H18V22.5H22.5V18H21V21Z" }),
    React.createElement("path", { d: "M18 1.5V3H21V6H22.5V1.5H18Z" }),
    React.createElement("path", { d: "M4.5 19.5H19.5V4.5H4.5V19.5ZM13.5 18H12V16.5H13.5V18ZM13.5 6H18V13.5H16.5V10.5H13.5V6ZM6 13.5H7.5V12H9V13.5H12V12H10.5V10.5H6V6H10.5V7.5H12V9H10.5V10.5H12V12H15V15H18V16.5H16.5V18H15V15H13.5V13.5H12V15H10.5V18H6V13.5Z" }),
    React.createElement("path", { d: "M16.5 7.5H15V9H16.5V7.5Z" }),
    React.createElement("path", { d: "M9 15H7.5V16.5H9V15Z" }),
    React.createElement("path", { d: "M9 7.5H7.5V9H9V7.5Z" })), 'QRCodeFilled');
